module.exports = __webpack_public_path__ + "img/undraw_through_the_park_lxnl.fd40700f.svg";